import types from './types';
import {promiseAction, ActionError} from '~/misc/dispatch';
import {searchDetailsList} from '~/api/search';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';

const getLoadsDetailPage = (data) => (dispatch, getState) => {
  let fromGeo = data.from_location || null;

  let tomorrow3 = format(addDays(new Date(data.from_date_local.split('T')[0]), 3), 'YYYY-MM-DD');

  let date_local_today = {
    from: `${data.from_date_local.split('T')[0]}T00:00:00`,
    to: `${tomorrow3}T23:59:59`,
  }

  let today = format(new Date(), 'YYYY-MM-DD');
  let cTomorrow3 = format(addDays(new Date(), 3), 'YYYY-MM-DD');

  let date_local_tomorrow = {
    from: `${today}T00:00:00`,
    to: `${cTomorrow3}T23:59:59`,
  }
  let todayA2Any = {
    query: {
      pickup: {
        geo: {
          location: fromGeo,
          deadhead: {max: 200}
        },
        date_local: date_local_today,
      },
      equipment: data.equipment || [],
      load_size: data.load_size || '',
      book_now: data.book_now || false,
    },
    options: {
      book_now_first: false
    },
    limit: 50,
    offset: 0
  }
  let tomorrowA2Any = {
    query: {
      pickup: {
        geo: {
          location: fromGeo,
          deadhead: {
            max: 200
          }
        },
        date_local: date_local_tomorrow,
      },
      equipment: data.equipment || [],
      load_size: data.load_size || '',
      book_now: data.book_now || false,
    },
    options: {
      book_now_first: false
    },
    limit: 50,
    offset: 0
  }

  return promiseAction(
    dispatch,
    getState,
    types.DETAILS_LOADS_SEARCH,
    Promise.all([
      searchDetailsList(getState, todayA2Any),
      searchDetailsList(getState, tomorrowA2Any),
      new Promise(((resolve, reject) => resolve(data.id)))
    ])
  )
};

export default getLoadsDetailPage;



// WEBPACK FOOTER //
// ./src/modules/loadDetails/actions.js